import * as React from 'react';
import { Button } from '@mui/material';
import { useFilterList } from '../../../context/FilterListProvider';

interface IData {
    [key: string]: any;
}

const ApproveButton: React.FC<IData> = ({ callback }) => {
    const [filterList] = useFilterList();
    let isSkipIncluded = filterList.Tags_contains?.some(tag => tag.toLowerCase() === 'skip');
    return (
        <>
            {!isSkipIncluded && <Button variant='contained' color='success' onClick={callback} sx={{ color: 'white' }}>approve</Button>}
        </>

    );
};

export default ApproveButton;